<div class="vin-search-container">
  <div style="display: flex;">
    <div>
      <div class="search-by-vin">
        <h2>您可以通过VIN码快速搜索</h2>
        <a nz-dropdown [nzDropdownMenu]="menu" [nzPlacement]="'bottomCenter'"
          style="padding: unset; border: unset; margin-left: auto;">
          <span class="scan-button" style="display: flex;">
            <div>
              <img class="mobile-icon" src="assets/mobile.svg">
            </div>
            <div style="color: #006EAD;">手机入口</div>
          </span>
        </a>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu style="display: flex;">
            <img class="scan-image" src="assets/official-website/scan-1.png">
            <img class="scan-image" src="assets/official-website/scan-2.png">
            <img class="scan-image" src="assets/official-website/scan-3.png">
          </ul>
        </nz-dropdown-menu>
      </div>

      <div class="vin-input-container">
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input type="text" nz-input [(ngModel)]="vinCode" placeholder="请输入17位VIN码" maxlength="17"
            (keyup)="checkVinLength()">
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i class="camera-icon" nz-icon nzType="camera" (click)="onUploadVinPhoto()"></i>
          <i class="search-icon" nz-icon nzType="search" (click)="onHandleSearch()"></i>
        </ng-template>
        <div *ngIf="vinError" class="error-message">VIN码必须为17位字符</div>
      </div>

      <div class="privacy-checkbox">
        <input type="checkbox" id="privacy" [(ngModel)]="privacyAgreed">
        <label for="privacy">我已阅读并同意关于VIN码搜索的</label>
        <span class="link" style="margin-left: 5px; font-size: 14px;" (click)="onHandlePrivacy()">隐私条款</span>
      </div>
    </div>
    <img style="margin-left: 20px; height: 190px;" src="assets/official-website/people-vehicle.png">
  </div>

  <div class="hot-brands">
    <h3>热搜品牌</h3>
    <div class="brands-grid">
      <div class="brand-icon brand-case" *ngFor="let car of hotBrands" [class.selected]="selectedBrandId === car?.id"
        (click)="selectBrand(car)">
        <div class="car-brand-item">
          <!-- <div class="brand-image">
            <img src={{car?.image}}>
          </div> -->
          <span class="brand-name">{{car?.brand}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="search-filters">
    <div class="filter-item filter-brand">
      <nz-select nzShowSearch nzAllowClear nzPlaceHolder="品牌" [(ngModel)]="selectedBrand" [nzFilterOption]="brandFilterOption"
        (ngModelChange)="onSelectBrandChange($event)">
        <nz-option *ngFor="let brand of allBrands" [nzLabel]="brand.brandName" [nzValue]="brand"></nz-option>
      </nz-select>
    </div>

    <div class="filter-item">
      <nz-select [(ngModel)]="selectedSeries" nzAllowClear nzPlaceHolder="车系" nzShowSearch [nzFilterOption]="seriesFilterOption"
        (ngModelChange)="onSelectSeriesChange($event)">
        <nz-option-group *ngFor="let group of allFilteredSeries" [nzLabel]="group.manufacturer">
          <nz-option *ngFor="let item of group.modelClassList" [nzValue]="item" [nzLabel]="item.modelClass"></nz-option>
        </nz-option-group>
      </nz-select>
    </div>

    <div class="filter-item filter-model">
      <nz-select nzShowSearch nzAllowClear nzPlaceHolder="型号" [(ngModel)]="selectedModel" [nzFilterOption]="modelFilterOption"
        (ngModelChange)="onSelectModelChange($event)">
        <nz-option *ngFor="let model of allFilteredModels" [nzLabel]="model.modelName"
          [nzValue]="model"></nz-option>
      </nz-select>
    </div>

    <div class="filter-item filter-displacement">
      <nz-select nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="排量" [(ngModel)]="selectedDisplacement"
        (ngModelChange)="onSelectDisplacementChange($event)">
        <nz-option *ngFor="let disp of allFilteredDisplacements" [nzLabel]="disp" [nzValue]="disp"></nz-option>
      </nz-select>
    </div>

    <div class="filter-item filter-year">
      <nz-select nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="年款" [(ngModel)]="selectedYear">
        <nz-option *ngFor="let year of allFilteredYears" [nzLabel]="year" [nzValue]="year"></nz-option>
      </nz-select>
    </div>
    <img style="width: 30px; height: 30px; cursor: pointer;" src="assets/official-website/reload.svg"
      (click)="handleResetFilter()">
    <button nz-button nzType="primary" style="width: 120px; height: 30px;" (click)="handleClickSearchCars()">搜索</button>
  </div>
  <div class="container">
    <div class="header" *ngIf="vehData.length>0" [class]="allChecked ? 'select-all-blue' : 'deselect-all'">
      <h2>全选({{ pageInfo.totalCounts }}) 条结果</h2>
    </div>

    <nz-table [nzLoading]="isCarTableLoading" #basicTable [nzData]="vehData" [nzPageSize]="pageSize" [nzShowPagination]="true"
      [nzFrontPagination]="false" [nzPageIndex]="pageIndex" (nzPageIndexChange)="onPageIndexChange($event)"
      nzShowSizeChanger (nzPageSizeChange)="onPageSizeChange($event)" [nzShowTotal]="totalTemplate"
      [nzTotal]="pageInfo.totalCounts" [nzLoading]="tableLoading">
      <thead>
        <tr>
          <th nzShowCheckbox [(nzChecked)]="allChecked" [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"></th>
          <th nzColumnKey="carBrandName" [nzSortFn]="sortCarBrandNameFn">品牌</th>
          <th nzColumnKey="modelClass" [nzSortFn]="sortModelClassFn">车系</th>
          <th nzColumnKey="carName" [nzSortFn]="sortCarNameFn">车型</th>
          <th nzColumnKey="displacement" [nzSortFn]="sortDisplacementFn">排量</th>
          <th nzColumnKey="modelYear" [nzSortFn]="sortYearFn">年款</th>
          <th nzColumnKey="carModelName" [nzSortFn]="sortCarModelNameFn">销售款型</th>
          <th nzColumnKey="engineCode" [nzSortFn]="sortEngineCodeFn">发动机号</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of basicTable.data">
          <td nzShowCheckbox [(nzChecked)]="checkedMap[item.carId]" (nzCheckedChange)="onItemChecked(item, $event)"></td>
          <td>{{ item.carBrandName }}</td>
          <td>{{ item.modelClass }}</td>
          <td>{{ item.carName }}</td>
          <td>{{ item.displacement }}</td>
          <td>{{ item.modelYear }}</td>
          <td>{{ item.carModelName }}</td>
          <td>{{ item.engineCode }}</td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #totalTemplate let-total>
      <span style="font-size: 16px; margin-right: 10px;">共{{pageInfo.totalCounts}}条</span>
    </ng-template>
    <button nz-button nzType="primary" style="float: right; width: 210px; height: 48px;"
      (click)="handleSearchParts()">下一步</button>

    <!-- <div class="footer">
      <span>共{{ data.length }}条</span>
      <span>10条/页</span>
      <nz-pagination [nzPageIndex]="pageIndex" [nzTotal]="30" [nzPageSize]="10"
        (nzPageIndexChange)="onPageIndexChange($event)"></nz-pagination>
      <div class="search-box">
        <input nz-input placeholder="搜索" [(ngModel)]="searchValue" (input)="search()" />
      </div>
    </div> -->
  </div>
</div>
<nz-modal [(nzVisible)]="isPrivacyVisible" nzTitle="提示" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <p style="margin: 20px 0;">
      当您使用【个人车辆信息：车辆VIN码】搜索相关配件时，请确保您已经过车主授权提供此信息给我们的【博世汽车配件在线目录】。如需查看详细的博世（中国）个人信息保护政策，请点击位于页面底部的“隐私”链接进行查看。</p>
  </ng-container>
</nz-modal>
<nz-modal [(nzVisible)]="isUploadVisible" nzTitle="上传VIN码照片" (nzOnCancel)="handleUploadCancel()"
  (nzOnOk)="handleUploadOk()">
  <ng-container *nzModalContent>
    <nz-upload class="upload-vin" nzType="drag" [nzCustomRequest]="handleChange">
      <p class="ant-upload-drag-icon">
        <i nz-icon nzType="cloud-upload"></i>
      </p>
      <p class="ant-upload-hint">
        将VIN码照片拖到此处，或点击上传
      </p>
    </nz-upload>
  </ng-container>
</nz-modal>
